import styled from 'styled-components';

export const Blank = styled.div`
  background: #fff;
  border: 1px solid #e1e7ed;

  @media (max-width: 909px) {
    margin-left: -20px;
    margin-right: -20px;
    border-left: 0;
    border-right: 0;
    min-height: 300px;
  }
`;
